export default {
  // 6.23添加2d管道  id为 10，11
	defaultBasicConfig: [{
		id: 1,
		name: "基本控件",
		content: [{
			id: 1,
			x: 0,//写算法时使用的x轴
			y: 0,//写算法时使用的y轴
			centerPointX: 0,//在组件上实际应用的x轴
			centerPointY: 0,//在组件上实际应用的y轴
			scaleX: 1,//在组件中通过改变scale来伸缩当前的x长度
			scaleY: 1,//在组件中通过改变scale来伸缩当前的y长度
			name: '文本标签',//控件名称 固定
			divName: '文本标签',//当前控件展示名称 可修改
			ShowActive: true,//是否显示  用作删除控件
			ImgUrl: null,//控件的图片地址
			NearEndImgUrl: null, //近端转接头的图片地址
			NearEndMark: false,//是否显示近端转接头
			NearNum: null,//近端转接头的id
			FarNum: null,//远端转接头的id
			FarEndImgUrl: null, //远端转接头的图片地址
			FarEndMark: false,//是否显示远端转接头
			width: 125,//写算法时使用的width
			height: 25,//写算法时使用的height
			fixeWidth:125,//在组件上实际应用的width 固定
			fixeHeight:25,//在组件上实际应用的height 固定
			rotateDeg: 0,//旋转角度
			ConnectPoint: [],//连接点数组 里面包括连接点所对应的斜对齐线
			ConnectMark: false, //连接点 显示开关
			zIndex: 1,//层级
			SkewAline: [],//设备的斜对齐线
			active: false, //是否被当前选中
			type: "span",//控件类型
			typeDefault: '基础控件',//控件类型
			NowActive: false, //当前选中的首选
			DeviceId: null,//当前所关联的设备id
			DeviceName: '',//当前所关联的设备name
			DevicePropCode: null,//当前所关联的设备的属性id
			DevicePropName: '',//当前所关联的设备的属性name
			DevicePropValue: '',//当前所关联的设备的属性value
			DeviceData: [],//存放当前关联属性v-model
			DeviceAttrType: {},//当前关联属性的类型
		},{
			id: 2,
			x: 0,
			y: 0,
			centerPointX: 0,
			centerPointY: 0,
			scaleX: 1,
			scaleY: 1,
			name: '属性看板',
			divName: '属性看板',
			ShowActive: true,
			ImgUrl: null,
			NearEndImgUrl: null, //8
			NearEndMark: false,
			NearNum: null,
			FarNum: null,
			FarEndImgUrl: null, //6
			FarEndMark: false,
			width: 135,
			height: 40,
			fixeWidth:135,
			fixeHeight:40,
			rotateDeg: 0,
			ConnectPoint: [],
			ConnectMark: false, //连接点 显示开关
			zIndex: 1,
			SkewAline: [],//设备斜对齐线
			active: false, //当前选中
			type: "Divspan",
			typeDefault: '基础控件',//控件类型
			NowActive: false, //当前选中的首选
			DeviceId: null,//当前所关联的设备id
			DeviceName: '',//当前所关联的设备name
			DevicePropCode: null,//当前所关联的设备的属性id
			DevicePropName: '',//当前所关联的设备的属性id
			DevicePropValue: '',//当前所关联的设备的属性value
			DeviceMultipleArray: [],//多选 所有关联属性数组 用于展示看板在编辑器上的选中数组
			DeviceMoth: [],//多选 所有关联属性数组 总数组
			ClickShowMark: false, //展开列表开关
			ShowTrueImgUrl: require('@/assets/image/editor/Device/spanDivTrue.png'),
			ShowFalseImgUrl: require('@/assets/image/editor/Device/spanDivFalse.png'),
		},{
			id: 3,
			x: 0,
			y: 0,
			centerPointX: 0,
			centerPointY: 0,
			scaleX: 1,
			scaleY: 1,
			name: '阀门竖',
			divName: '阀门竖',
			ShowActive: true,
			ImgUrl: require('@/assets/image/editor/Device/Horizontalvalve.png'),
			NearEndImgUrl: null, //8
			NearEndMark: false,
			NearNum: null,
			FarNum: null,
			FarEndImgUrl: null, //6
			FarEndMark: false,
			width: 15,
			height: 15,
			fixeWidth:15,
			fixeHeight:15,
			rotateDeg: 0,
			ConnectPoint: [],
			ConnectMark: false, //连接点 显示开关
			zIndex: 1,
			SkewAline: [],//设备斜对齐线
			active: false, //当前选中
			type: "valve",
			typeDefault: '基础控件',//控件类型
			NowActive: false, //当前选中的首选
			DeviceId: null,//当前所关联的设备id
			DeviceName: '',//当前所关联的设备name
			DevicePropCode: null,//当前所关联的设备的属性id
			DevicePropName: '',//当前所关联的设备的属性id
			DevicePropValue: '',//当前所关联的设备的属性value
			DeviceStateLightShow: false,//当前所关联的设备的状态指示灯开关
			DeviceState: null, //当前所关联的设备的状态
		},{
			id: 4,
			x: 0,
			y: 0,
			centerPointX: 0,
			centerPointY: 0,
			scaleX: 1,
			scaleY: 1,
			name: '阀门横',
			divName: '阀门横',
			ShowActive: true,
			ImgUrl: require('@/assets/image/editor/Device/Verticalvalve.png'),
			NearEndImgUrl: null, //8
			NearEndMark: false,
			NearNum: null,
			FarNum: null,
			FarEndImgUrl: null, //6
			FarEndMark: false,
			width: 15,
			height: 15,
			fixeWidth:15,
			fixeHeight:15,
			rotateDeg: 0,
			ConnectPoint: [],
			ConnectMark: false, //连接点 显示开关
			zIndex: 1,
			SkewAline: [],//设备斜对齐线
			active: false, //当前选中
			type: "valve",
			typeDefault: '基础控件',//控件类型
			NowActive: false, //当前选中的首选
			DeviceId: null,//当前所关联的设备id
			DeviceName: '',//当前所关联的设备name
			DevicePropCode: null,//当前所关联的设备的属性id
			DevicePropName: '',//当前所关联的设备的属性id
			DevicePropValue: '',//当前所关联的设备的属性value
			DeviceStateLightShow: false,//当前所关联的设备的状态指示灯开关
			DeviceState: null, //当前所关联的设备的状态
		},{
			id: 5,
			x: 0,
			y: 0,
			centerPointX: 0,
			centerPointY: 0,
			scaleX: 1,
			scaleY: 1,
			name: '仪表竖',
			divName: '仪表竖',
			ShowActive: true,
			ImgUrl: require('@/assets/image/editor/Device/Verticalwatch.png'),
			NearEndImgUrl: null, //8
			NearEndMark: false,
			NearNum: null,
			FarNum: null,
			FarEndImgUrl: null, //6
			FarEndMark: false,
			width: 25,
			height: 27,
			fixeWidth:25,
			fixeHeight:27,
			rotateDeg: 0,
			ConnectPoint: [],
			ConnectMark: false, //连接点 显示开关
			zIndex: 1,
			SkewAline: [],//设备斜对齐线
			active: false, //当前选中
			type: "watch",
			typeDefault: '基础控件',//控件类型
			NowActive: false, //当前选中的首选
			DeviceId: null,//当前所关联的设备id
			DeviceName: '',//当前所关联的设备name
			DevicePropCode: null,//当前所关联的设备的属性id
			DevicePropName: '',//当前所关联的设备的属性id
			DevicePropValue: '',//当前所关联的设备的属性value
			DeviceStateLightShow: false,//当前所关联的设备的状态指示灯开关
			DeviceState: null, //当前所关联的设备的状态
		},{
			id: 6,
			x: 0,
			y: 0,
			centerPointX: 0,
			centerPointY: 0,
			scaleX: 1,
			scaleY: 1,
			name: '仪表横',
			divName: '仪表横',
			ShowActive: true,
			ImgUrl: require('@/assets/image/editor/Device/Horizontalwatch.png'),
			NearEndImgUrl: null, //8
			NearEndMark: false,
			NearNum: null,
			FarNum: null,
			FarEndImgUrl: null, //6
			FarEndMark: false,
			width: 28,
			height: 22,
			fixeWidth:28,
			fixeHeight:22,
			rotateDeg: 0,
			ConnectPoint: [],
			ConnectMark: false, //连接点 显示开关
			zIndex: 1,
			SkewAline: [],//设备斜对齐线
			active: false, //当前选中
			type: "watch",
			typeDefault: '基础控件',//控件类型
			NowActive: false, //当前选中的首选
			DeviceId: null,//当前所关联的设备id
			DeviceName: '',//当前所关联的设备name
			DevicePropCode: null,//当前所关联的设备的属性id
			DevicePropName: '',//当前所关联的设备的属性id
			DevicePropValue: '',//当前所关联的设备的属性value
			DeviceStateLightShow: false,//当前所关联的设备的状态指示灯开关
			DeviceState: null, //当前所关联的设备的状态
		},{
			id: 7,
			x: 0,
			y: 0,
			centerPointX: 0,
			centerPointY: 0,
			scaleX: 1,
			scaleY: 1,
			name: 'X轴管道',
			divName: 'X轴管道',
			colorId: 1,
			direction: 0,
			ShowActive: true,
			ImgUrl: require('@/assets/image/editor/gray.png'),
			NearEndImgUrl: null, //8
			NearEndMark: false,
			NearNum: null,
			FarNum: null,
			FarEndImgUrl: null, //6
			FarEndMark: false,
			width: 84,
			height: 8,
			fixeWidth:84,
			fixeHeight:8,
			rotateDeg: -30,
			ConnectPoint: [{
				type: 'conduit0',
				x: 4,
				y: 4,
				typeObj: 'left',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit0',
				x: 84,
				y: 4,
				typeObj: 'right',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit-30',
				x: 0,
				y: 4,
				typeObj: 'left',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit30',
				x: 0,
				y: 4,
				typeObj: 'left',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit-30',
				x: 84,
				y: 4,
				typeObj: 'right',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit30',
				x: 84,
				y: 4,
				typeObj: 'right',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit90',
				x: 0,
				y: 4,
				typeObj: 'left',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit90',
				x: 84,
				y: 4,
				typeObj: 'right',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'img',
				x: 0,
				y: 4,
				typeObj: 'left',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'img',
				x: 84,
				y: 4,
				typeObj: 'right',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			}], //连接点，以左上角为基点(0,0)
			ConnectMark: false, //连接点 显示开关
			zIndex: 10,
			SkewAline: [],//设备斜对齐线
			active: false, //当前选中
			type: "conduit-30",
			typeDefault: '基础控件',//控件类型
			NowActive: false, //当前选中的首选
			DeviceId: null,//当前所关联的设备id
			DeviceName: '',//当前所关联的设备name
			DevicePropCode: null,//当前所关联的设备的属性id
			DevicePropName: '',//当前所关联的设备的属性id
			DevicePropValue: '',//当前所关联的设备的属性value
			DeviceData: [],//存放当前关联属性v-model
			DeviceAttrType: {},//当前关联属性的类型
			thresholdMark: false,//阈值开关
			thresholdSymbol: '',//阈值比较符
			thresholdValue: '',//阈值比较值
			ValueOptions:[],//存放enum或bool的数组
			ProductCode: '',//当前所关联的设备的产品code
			imageGif: require('@/assets/image/editor/gray_gif.gif'),//gif
			imagePng: require('@/assets/image/editor/gray_png.png')//png
		},{
			id: 8,
			x: 0,
			y: 0,
			centerPointX: 0,
			centerPointY: 0,
			scaleX: 1,
			scaleY: 1,
			name: 'Y轴管道',
			divName: 'Y轴管道',
			colorId: 1,
			direction: 0,
			ShowActive: true,
			ImgUrl: require('@/assets/image/editor/gray.png'),
			NearEndImgUrl: null, //8
			NearEndMark: false,
			NearNum: null,
			FarNum: null,
			FarEndImgUrl: null, //6
			FarEndMark: false,
			width: 84,
			height: 8,
			fixeWidth:84,
			fixeHeight:8,
			rotateDeg: 30,
			ConnectPoint: [{
				type: 'conduit0',
				x: 4,
				y: 4,
				typeObj: 'left',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit0',
				x: 84,
				y: 4,
				typeObj: 'right',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit-30',
				x: 0,
				y: 4,
				typeObj: 'left',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit30',
				x: 0,
				y: 4,
				typeObj: 'left',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit-30',
				x: 84,
				y: 4,
				typeObj: 'right',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit-30',
				x: 84,
				y: 4,
				typeObj: 'right',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit90',
				x: 0,
				y: 4,
				typeObj: 'left',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit90',
				x: 84,
				y: 4,
				typeObj: 'right',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'img',
				x: 0,
				y: 4,
				typeObj: 'left',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			}], //连接点，以左上角为基点(0,0)
			ConnectMark: false, //连接点 显示开关
			zIndex: 10,
			SkewAline: [],//设备斜对齐线
			active: false, //当前选中
			type: "conduit30",
			typeDefault: '基础控件',//控件类型
			NowActive: false, //当前选中的首选
			DeviceId: null,//当前所关联的设备id
			DeviceName: '',//当前所关联的设备name
			DevicePropCode: null,//当前所关联的设备的属性id
			DevicePropName: '',//当前所关联的设备的属性id
			DevicePropValue: '',//当前所关联的设备的属性value
			DeviceData: [],//存放当前关联属性v-model
			DeviceAttrType: {},//当前关联属性的类型
			thresholdMark: false,//阈值开关
			thresholdSymbol: '',//阈值比较符
			thresholdValue: '',//阈值比较值
			ValueOptions:[],//存放enum或bool的数组
			ProductCode: '',//当前所关联的设备的产品code
			imageGif: require('@/assets/image/editor/gray_gif.gif'),//gif
			imagePng: require('@/assets/image/editor/gray_png.png')//png
		},{
			id: 9,
			x: 0,
			y: 0,
			centerPointX: 0,
			centerPointY: 0,
			scaleX: 1,
			scaleY: 1,
			name: 'Z轴管道',
			divName: 'Z轴管道',
			colorId: 1,
			direction: 0,
			ShowActive: true,
			ImgUrl: require('@/assets/image/editor/gray.png'),
			NearEndImgUrl: null, //8
			NearEndMark: false,
			NearNum: null,
			FarNum: null,
			FarEndImgUrl: null, //6
			FarEndMark: false,
			width: 8,
			height: 84,
			fixeWidth:8,
			fixeHeight:84,
			rotateDeg: 90,
			ConnectPoint: [{
				type: 'conduit0',
				x: 4,
				y: 4,
				typeObj: 'left',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit0',
				x: 4,
				y: 84,
				typeObj: 'right',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit-30',
				x: 4,
				y: 0,
				typeObj: 'left',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit30',
				x: 4,
				y: 0,
				typeObj: 'left',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit-30',
				x: 4,
				y: 84,
				typeObj: 'right',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit30',
				x: 4,
				y: 84,
				typeObj: 'right',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'img',
				x: 4,
				y: 84,
				typeObj: 'right',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			}], //连接点，以左上角为基点(0,0)
			ConnectMark: false, //连接点 显示开关
			zIndex: 10,
			SkewAline: [],//设备斜对齐线
			active: false, //当前选中
			type: "conduit90",
			typeDefault: '基础控件',//控件类型
			NowActive: false, //当前选中的首选
			DeviceId: null,//当前所关联的设备id
			DeviceName: '',//当前所关联的设备name
			DevicePropCode: null,//当前所关联的设备的属性id
			DevicePropName: '',//当前所关联的设备的属性id
			DevicePropValue: '',//当前所关联的设备的属性value
			DeviceData: [],//存放当前关联属性v-model
			DeviceAttrType: {},//当前关联属性的类型
			thresholdMark: false,//阈值开关
			thresholdSymbol: '',//阈值比较符
			thresholdValue: '',//阈值比较值
			ValueOptions:[],//存放enum或bool的数组
			ProductCode: '',//当前所关联的设备的产品code
			imageGif: require('@/assets/image/editor/gray_top_gif.gif'),//gif
			imagePng: require('@/assets/image/editor/gray_top_png.png')//png
		},{
			id: 10,
			x: 0,
			y: 0,
			centerPointX: 0,
			centerPointY: 0,
			scaleX: 1,
			scaleY: 1,
			name: 'Y轴管道-2D',
			divName: 'Y轴管道-2D',
			colorId: 1,
			direction: 0,
			ShowActive: true,
			ImgUrl: require('@/assets/image/editor/gray.png'),
			NearEndImgUrl: null, //8
			NearEndMark: false,
			NearNum: null,
			FarNum: null,
			FarEndImgUrl: null, //6
			FarEndMark: false,
			width: 8,
			height: 84,
			fixeWidth:8,
			fixeHeight:84,
			rotateDeg: 90,
			ConnectPoint: [{
				type: 'conduit0',
				x: 4,
				y: 4,
				typeObj: 'left',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit0',
				x: 4,
				y: 84,
				typeObj: 'right',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit-30',
				x: 0,
				y: 4,
				typeObj: 'left',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit30',
				x: 0,
				y: 4,
				typeObj: 'left',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit-30',
				x: 84,
				y: 4,
				typeObj: 'right',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit-30',
				x: 84,
				y: 4,
				typeObj: 'right',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit90',
				x: 0,
				y: 4,
				typeObj: 'left',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit90',
				x: 84,
				y: 4,
				typeObj: 'right',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'img',
				x: 0,
				y: 4,
				typeObj: 'left',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			}], //连接点，以左上角为基点(0,0)
			ConnectMark: false, //连接点 显示开关
			zIndex: 10,
			SkewAline: [],//设备斜对齐线
			active: false, //当前选中
			type: "conduit90",
			typeDefault: '基础控件',//控件类型
			NowActive: false, //当前选中的首选
			DeviceId: null,//当前所关联的设备id
			DeviceName: '',//当前所关联的设备name
			DevicePropCode: null,//当前所关联的设备的属性id
			DevicePropName: '',//当前所关联的设备的属性id
			DevicePropValue: '',//当前所关联的设备的属性value
			DeviceData: [],//存放当前关联属性v-model
			DeviceAttrType: {},//当前关联属性的类型
			thresholdMark: false,//阈值开关
			thresholdSymbol: '',//阈值比较符
			thresholdValue: '',//阈值比较值
			ValueOptions:[],//存放enum或bool的数组
			ProductCode: '',//当前所关联的设备的产品code
			imageGif: require('@/assets/image/editor/gray_top_gif.gif'),//gif
			imagePng: require('@/assets/image/editor/gray_top_png.png')//png
		},{
			id: 11,
			x: 0,
			y: 0,
			centerPointX: 0,
			centerPointY: 0,
			scaleX: 1,
			scaleY: 1,
			name: 'X轴管道-2D',
			divName: 'X轴管道-2D',
			colorId: 1,
			direction: 0,
			ShowActive: true,
			ImgUrl: require('@/assets/image/editor/gray.png'),
			NearEndImgUrl: null, //8
			NearEndMark: false,
			NearNum: null,
			FarNum: null,
			FarEndImgUrl: null, //6
			FarEndMark: false,
			width: 84,
			height: 8,
			fixeWidth:84,
			fixeHeight:8,
			rotateDeg: 0,
			ConnectPoint: [{
				type: 'conduit90',
				x: 4,
				y: 4,
				typeObj: 'left',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit90',
				x: 84,
				y: 4,
				typeObj: 'right',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit-30',
				x: 0,
				y: 4,
				typeObj: 'left',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit30',
				x: 0,
				y: 4,
				typeObj: 'left',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit-30',
				x: 84,
				y: 4,
				typeObj: 'right',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit30',
				x: 84,
				y: 4,
				typeObj: 'right',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'img',
				x: 0,
				y: 4,
				typeObj: 'left',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'img',
				x: 84,
				y: 4,
				typeObj: 'right',
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			}], //连接点，以左上角为基点(0,0)
			ConnectMark: false, //连接点 显示开关
			zIndex: 10,
			SkewAline: [],//设备斜对齐线
			active: false, //当前选中
			type: "conduit0",
			typeDefault: '基础控件',//控件类型
			NowActive: false, //当前选中的首选
			DeviceId: null,//当前所关联的设备id
			DeviceName: '',//当前所关联的设备name
			DevicePropCode: null,//当前所关联的设备的属性id
			DevicePropName: '',//当前所关联的设备的属性id
			DevicePropValue: '',//当前所关联的设备的属性value
			DeviceData: [],//存放当前关联属性v-model
			DeviceAttrType: {},//当前关联属性的类型
			thresholdMark: false,//阈值开关
			thresholdSymbol: '',//阈值比较符
			thresholdValue: '',//阈值比较值
			ValueOptions:[],//存放enum或bool的数组
			ProductCode: '',//当前所关联的设备的产品code
			imageGif: require('@/assets/image/editor/gray_gif.gif'),//gif
			imagePng: require('@/assets/image/editor/gray_png.png')//png
		}]
	}],

	defaultDeviceConfig:[{
		id: 1,
		name: '空压机',
		content: [{
			id: 1,
			x: 0,
			y: 0,
			centerPointX: 0,
			centerPointY: 0,
			scaleX: 1,
			scaleY: 1,
			name: '空压机1号',
			divName: '空压机1号',
			ShowActive: true,
			ImgUrl: require('@/assets/image/editor/Device/Compressor.png'),
			width: 116,
			height: 154,
			fixeWidth:116,
			fixeHeight:154,
			rotateDeg: 0,
			ConnectPoint: [{
				type: 'conduit30',
				x: 40,
				y: 135,
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit90',
				x: 38,
				y: 43,
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			},{
				type: 'conduit0',
				x: 38,
				y: 43,
				Mark: false,
				SkewAline: [{
					name: "LeftTop",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftTop_vm",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom",
					Mark: false,
					width: 0, //长度
				}, {
					name: "LeftBottom_vm",
					Mark: false,
					width: 0, //长度
				}], //斜线对齐 显示参数
			}], //连接点，以左上角为基点(0,0)
			ConnectMark: false, //连接点 显示开关
			zIndex: 1,
			SkewAline: [{
				name: "LeftTop",
				Mark: false,
				width: 0, //长度
			}, {
				name: "LeftTop_vm",
				Mark: false,
				width: 0, //长度
			}, {
				name: "LeftBottom",
				Mark: false,
				width: 0, //长度
			}, {
				name: "LeftBottom_vm",
				Mark: false,
				width: 0, //长度
			}, {
				name: "RightTop",
				Mark: false,
				width: 0, //长度
			}, {
				name: "RightTop_vm",
				Mark: false,
				width: 0, //长度
			}, {
				name: "RightBottom",
				Mark: false,
				width: 0, //长度
			}, {
				name: "RightBottom_vm",
				Mark: false,
				width: 0, //长度
			}], //斜线对齐 显示参数
			active: false, //当前选中
			type: "img",
			typeDefault: '企业控件',//控件类型
			NowActive: false, //当前选中的首选
			DeviceId: null,//当前所关联的设备id
			DeviceName: '',//当前所关联的设备name
			DevicePropCode: null,//当前所关联的设备的属性id
			DevicePropName: '',//当前所关联的设备的属性id
			DevicePropValue: '',//当前所关联的设备的属性value
		}]
	}]
}



// WEBPACK FOOTER //
// ./src/vueX/model/defaultConfig.js